import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { $isHeadingNode } from "@lexical/rich-text";

export default function TitleWatcherPlugin({ onTitleChange }) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!onTitleChange) return;

        return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const root = $getRoot();
                const firstChild = root.getFirstChild();

                if (firstChild && $isHeadingNode(firstChild) && firstChild.getTag() === "h1") {
                    const titleText = firstChild.getTextContent().trim();
                    onTitleChange(titleText);
                } else {
                    onTitleChange(""); // no valid h1
                }
            });
        });
    }, [editor, onTitleChange]);

    return null;
}
